var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8925 16.7162H19.7854V10.609C19.7854 10.4322 19.6408 10.2876 19.464 10.2876H17.5354C17.3586 10.2876 17.214 10.4322 17.214 10.609V16.7162H11.1068C10.93 16.7162 10.7854 16.8608 10.7854 17.0376V18.9662C10.7854 19.143 10.93 19.2876 11.1068 19.2876H17.214V25.3947C17.214 25.5715 17.3586 25.7162 17.5354 25.7162H19.464C19.6408 25.7162 19.7854 25.5715 19.7854 25.3947V19.2876H25.8925C26.0693 19.2876 26.214 19.143 26.214 18.9662V17.0376C26.214 16.8608 26.0693 16.7162 25.8925 16.7162Z",
    fill: "#A0A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0C8.55982 0 0.5 8.05982 0.5 18C0.5 27.9402 8.55982 36 18.5 36C28.4402 36 36.5 27.9402 36.5 18C36.5 8.05982 28.4402 0 18.5 0ZM18.5 32.9464C10.2473 32.9464 3.55357 26.2527 3.55357 18C3.55357 9.74732 10.2473 3.05357 18.5 3.05357C26.7527 3.05357 33.4464 9.74732 33.4464 18C33.4464 26.2527 26.7527 32.9464 18.5 32.9464Z",
    fill: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/add-file.c6bf1782d039a059af92e2ab00d1d4fe.svg";
export { ForwardRef as ReactComponent };